import { Divider } from 'antd';
import cx from 'classnames';
import React, { CSSProperties, FC } from 'react';
import { CanvasInfo } from '../../../../model/BadgeModel';
import { AddTextIcon, FilledCircleIcon, FilledRectangleIcon, FreeHandIcon, SelectArrowIcon } from '../../../../resources/Icons';
import { MenuItems, withMenuActions } from '../../../graphic';
import styles from './toolsMenu.module.scss';

const SelectArrowStyle: CSSProperties = { fontSize: 18 };
const FreeHandStyle: CSSProperties = { fontSize: 16, stroke: '#656565' };
const FilledRectangleStyle: CSSProperties = { fontSize: 21, fill: '#D4D3D3', stroke: '#656565' };
const FilledCircleStyle: CSSProperties = { fontSize: 16, fill: '#A0A0A0', stroke: '#656565' };
const AddTextStyle: CSSProperties = { fontSize: 26 };

const ToolsMenu: FC<CanvasInfo> = withMenuActions(({ disabled, handleMenuActions }) => {
	return (
		<div className={styles.toolMenuBar}>
			<ul>
				<li className={cx({ [styles.disabled]: disabled })} key={MenuItems.Selection} onClick={() => handleMenuActions(MenuItems.Select)}>
					<span title={_('Selection')}>
						<SelectArrowIcon style={SelectArrowStyle} />
					</span>
				</li>
				<Divider className={styles.divider} />
				<li
					className={cx({ [styles.disabled]: disabled })}
					key={MenuItems.RedlineFreeHand}
					onClick={() => handleMenuActions(MenuItems.RedlineFreeHand)}>
					<span title={_('Line')}>
						<FreeHandIcon style={FreeHandStyle} />
					</span>
				</li>
				<Divider className={styles.divider} />
				<li
					className={cx({ [styles.disabled]: disabled })}
					key={MenuItems.RedlineFilledRectangle}
					onClick={() => handleMenuActions(MenuItems.RedlineFilledRectangle)}>
					<span title={_('RectangleFill')}>
						<FilledRectangleIcon style={FilledRectangleStyle} />
					</span>
				</li>
				<Divider className={styles.divider} />
				<li className={cx({ [styles.disabled]: disabled })} key={MenuItems.RedlineCircle} onClick={() => handleMenuActions(MenuItems.RedlineCircle)}>
					<span title={_('Circle')}>
						<FilledCircleIcon style={FilledCircleStyle} />
					</span>
				</li>
				<Divider className={styles.divider} />
				<li className={cx({ [styles.disabled]: disabled })} key={MenuItems.AddText} onClick={() => handleMenuActions(MenuItems.AddText)}>
					<span title={_('AddText')}>
						<AddTextIcon style={AddTextStyle} />
					</span>
				</li>
			</ul>
		</div>
	);
});

export { ToolsMenu };
